import { render } from "./emergency.vue?vue&type=template&id=55a01b3c&scoped=true"
import script from "./emergency.vue?vue&type=script&lang=js"
export * from "./emergency.vue?vue&type=script&lang=js"

import "./emergency.vue?vue&type=style&index=0&id=55a01b3c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a01b3c"]])

export default __exports__